<template>
  <div>
    <template v-if="$helper.currencyOptions && $helper.currencyOptions.length > 1">
      <v-tabs
        v-model="tab" 
        color="primary"
        slider-color="primary"
        background-color="white"
        class="tab-custom-inline">
        <template v-for="currency in $helper.currencyOptions">
          <v-tab :value="currency.value" :href="`#${currency.value}`" @click="onSelectTab(currency.value)" :key="`tab-meter-${currency.value}`">
            <img :src="`/images/currency/${currency.value}.svg`" :alt="currency.value" class="mr-2 tab-icon-flag">
            {{ currency.tabName }}
          </v-tab>
        </template>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="currency in $helper.currencyOptions" :key="currency.value" :value="`${currency.value}`">
          <market-setting-meter 
          :isMainLoading="isMainLoading" 
          :meterSettingItems="meterSettingItems"
          @onSaveMeter="saveMeter" 
          @onInitMeterSetting="onInitMeterSetting" 
          :marketId="marketId" 
          :meterType="meterType"
          :tabType="currency.value"></market-setting-meter>
        </v-tab-item>
      </v-tabs-items>
    </template>
    <template v-else>
      <market-setting-meter 
        :isMainLoading="isMainLoading"
        :meterSettingItems="meterSettingItems"
        @onSaveMeter="saveMeter" 
        @onInitMeterSetting="onInitMeterSetting"
        :marketId="marketId"
        :meterType="meterType"
        :tabType="tab">
      </market-setting-meter>
    </template>
  </div>
</template>

<script>
import MarketSettingMeter from "@/components/MarketSettingMeter.component.vue";
export default {
  components: {
    MarketSettingMeter
  },
  props: {
    isMainLoading: Boolean,
    marketId: String,
    meterSettingItems: Array,
    meterType: String,
  },
  data() {
    return {
      tab: this.$globalCurrencyCode
    };
  },
  methods: {
    saveMeter(formData) {
      this.$emit("onSaveMeter", formData);
    },
    onInitMeterSetting() {
      this.$emit("onInitMeterSetting");
    },
    onSelectTab(tab) {
      this.tab = tab;
      this.$emit("onInitMeterSetting");
      this.$emit("onSelectTab", tab);
    }
  }
};
</script>

<style>

</style>